import React, { useState, useEffect, useRef } from 'react';

import { Submenu, SubmenuItem, Tabela } from '../../components';
import { etfService } from '../../service/services/EtfService';
import { Hidden } from '@material-ui/core';


import {
	Title,
	Container,
	RazaoSocial,
	Tributos,
	TributosConteudo,
	TributosBloco,
	TributosCaracteristica,
	TributosTabela,
	TributosLegenda,
	Encargos,
	EncargosConteudo,
	EncargosBloco,
} from './styles';

import { formatDbDate, smoothScroll } from '../../utils/functions';

const getTributo = (list, type) => {
	let result = list.filter(item => item.TipoTibuto === type);

	result = result.map(e => [
		e.TipoInvestidor,
		e.IRAliquota,
		e.ResponsavelRecolhimento,
	]);

	return result;
};

export default () => {
	const [informacoesData, setInformacoesData] = useState([]);
	const [alienacaoData, setAlienacaoData] = useState([]);
	const [integralizacaoData, setIntegralizacaoData] = useState([]);
	const [resgateData, setResgateData] = useState([]);

	const [encargosData, setEncargosData] = useState('');

	const informacoesRef = useRef(null);
	const alienacaoRef = useRef(null);
	const integralizacaoRef = useRef(null);
	const resgateRef = useRef(null);
	const encargosRef = useRef(null);

	const getResult = async () => {
		try {
			const response = await etfService.Caracteristicas();
			const responseData = await response.data;

			const alienacao = getTributo(
				responseData.ObjJsonResultado.Tributos,
				'AlienacaoCotasBolsaValores',
			);
			const integralizacao = getTributo(
				responseData.ObjJsonResultado.Tributos,
				'IntegralizacaoCotasAtivos',
			);
			const resgate = getTributo(
				responseData.ObjJsonResultado.Tributos,
				'ResgateCotasAtivos',
			);

			setInformacoesData(responseData.ObjJsonResultado);
			setAlienacaoData(alienacao);
			setIntegralizacaoData(integralizacao);
			setResgateData(resgate);
			setEncargosData(responseData.ObjJsonResultado.Encargos);
		} catch (err) {
			console.error(
				'Ocorreu um erro ao chamar a API de Composição - Erro: ',
				err,
			);
		}
	};

	useEffect(() => {
		const getData = async () => {
			await getResult();
		};

		getData();
	}, []);

	return (
		<Container>
			<Hidden mdUp>
				<Title>Características</Title>
			</Hidden>
			<Hidden smDown>
				<Submenu>
					<SubmenuItem
						onClick={() => smoothScroll('#informacoes')}
						label="Informações ETF"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#tributos')}
						label="Tributos"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#encargos')}
						label="Encargos"
					/>
				</Submenu>
			</Hidden>

			<RazaoSocial ref={informacoesRef}>
				<div id="informacoes">
					<h2>Razão social</h2>
					<Tabela
						highlight="Razão social"
						headers={[
							'Razão social',
							'BTG PACTUAL TEVA AÇÕES COMMODITIES BRASIL FUNDO DE ÍNDICE',
						]}
					>
						<tr>
							<td>Ticker</td>
							<td>{informacoesData.Ticker}</td>
						</tr>
						<tr>
							<td>Índice de referência</td>
							<td>{informacoesData.IndiceReferencia}</td>
						</tr>
						<tr>
							<td>Código ISIN</td>
							<td>{informacoesData.CodISINFundo}</td>
						</tr>
						<tr>
							<td>Gestor</td>
							<td>{informacoesData.Gestor}</td>
						</tr>
						<tr>
							<td>Administrador</td>
							<td>{informacoesData.Administrador}</td>
						</tr>
						<tr>
							<td>Custodiante</td>
							<td>{informacoesData.Custodiante}</td>
						</tr>
						<tr>
							<td>Formador de mercado</td>
							<td>{informacoesData.FormadorMercado}</td>
						</tr>
						<tr>
							<td>Agente autorizado</td>
							<td>{informacoesData.AgenteAutorizado}</td>
						</tr>
						<tr>
							<td>Data de início</td>
							<td>
								{informacoesData &&
									informacoesData.DataInicio &&
									formatDbDate('DD/MM/YYYY', informacoesData?.DataInicio)}
							</td>
						</tr>
						<tr>
							<td>Taxa de administração</td>
							<td>{informacoesData.TaxaAdministracao}</td>
						</tr>
					</Tabela>
				</div>
			</RazaoSocial>

			<Tributos>
				<TributosConteudo ref={alienacaoRef}>
					<TributosBloco>
						<h2 id="tributos">Tributos</h2>
						<div>
							<h3 id="alienacao">
								Alienação de cotas em bolsa de valores (secundário)
							</h3>
							<TributosTabela>
								<Tabela
									headers={[
										'Tipo de Investidor',
										'IR Alíquota',
										'Responsável pelo recolhimento',
									]}
									data={alienacaoData}
								/>
							</TributosTabela>
							<TributosLegenda>
								* O ganho é isento caso o valor das ações integralizadas no mês
								seja inferior a R$ 20 mil.
								<br />
								** Dispensado de retenção (art. 774 do RIR/99)
								<br />
								*** A alienação realizada em Bolsa de Valores sujeita-se a
								retenção do IRF à alíquota de 0,005%, sobre o valor da
								alienação, sendo dispensada a retenção de valor inferior a RS
								1,00. Entende-se que se a Corretora receber diretamente a ordem
								do cliente, esta seria responsável pela retenção desse IRF.
							</TributosLegenda>
						</div>

						<TributosCaracteristica ref={integralizacaoRef}>
							<h3 id="integralizacao">
								Integralização de cotas com ativos (primário)
							</h3>
							<TributosTabela>
								<Tabela
									headers={[
										'Tipo de Investidor',
										'IR Alíquota',
										'Responsável pelo recolhimento',
									]}
									data={integralizacaoData}
								/>
							</TributosTabela>
							<TributosLegenda>
								<span>
									* O ganho é isento caso o valor das ações integralizadas no
									mês seja inferior a R$ 20 mil.
								</span>
								<span>** Dispensado de retenção (art. 774 do RIR/99)</span>
								<span>*** Tabela Progressiva:</span>
								<strong>
									15% sobre a parcela dos ganhos que não ultrapassar R$
									5.000.000,00
								</strong>
								<strong>
									17,5% sobre a parcela dos ganhos que exceder R$ 5.000.000,00 e
									não ultrapassar R$ 10.000.000,00
								</strong>
								<strong>
									20% sobre a parcela dos ganhos que exceder R$ 10.000.000,00 e
									não ultrapassar R$ 30.000.000,00
								</strong>
								<strong>
									22,5% sobre a parcela dos ganhos que ultrapassar R$
									30.000.000,00
								</strong>
							</TributosLegenda>
						</TributosCaracteristica>

						<TributosCaracteristica ref={resgateRef}>
							<h3 id="resgate">Resgate de cotas com ativos (primário)</h3>
							<TributosTabela>
								<Tabela
									headers={[
										'Tipo de Investidor',
										'IR Alíquota',
										'Responsável pelo recolhimento',
									]}
									data={resgateData}
								/>
							</TributosTabela>
							<TributosLegenda>
								* Dispensado de retenção (art. 774 do RIR/99)
							</TributosLegenda>
						</TributosCaracteristica>

						<TributosCaracteristica>
							<h3>Observações</h3>
							<TributosLegenda>
								<span>O IOF-TVM incidirá à alíquota zero.</span>
								<span>Não há incidência do Come-Cotas.</span>
								<span>
									Como regra geral, haverá retenção de IR de 0,005% com exceção
									de casos previstos expressamente na legislação, tais como:
									fundos de investimento, instituições financeiras, INRs 4373
									não paraíso.
								</span>
								<span>
									As tabelas acima resumem as principais alíquotas por tipo de
									investidor e não dispensam a consulta da Legislação Tributária
									e consultores próprios.
								</span>
								<span>
									Os rendimentos e ganhos auferidos com operações realizadas
									pela carteira do Fundo não estão sujeitos ao IR.
								</span>
							</TributosLegenda>
						</TributosCaracteristica>
					</TributosBloco>
				</TributosConteudo>
			</Tributos>

			<Encargos>
				<EncargosConteudo ref={encargosRef}>
					<h2 id="encargos">Encargos</h2>
					<p style={{whiteSpace: "pre-line", textAlign: "justify"}}>
						{encargosData}
						
					</p>
					

					<EncargosBloco>
						<Tabela headers={['Despesas', 'Patrimônio Líquido Médio (%)']}>
							{/* <tr>
								<td>Corretagem e emolumentos</td>
								<td>0,0001</td>
							</tr> */}
							<tr>
								<td colSpan="2" style={{ textAlign: 'center' }}>
									Não há dados a serem exibidos
								</td>
							</tr>
						</Tabela>

						<p>
							* Despesas apuradas entre 29/11/2021 a 31/03/2022. O percentual representa o 
							valor total debitado do fundo em relação ao patrimônio líquido diário médio 
							do fundo no mesmo período.
						</p>
					</EncargosBloco>
				</EncargosConteudo>
			</Encargos>
		</Container>
	);
};
